import { Currency } from '@/core/currency/interfaces';

const SSP: Currency = {
    name: 'South Sudanese Pound',
    demonym: 'South Sudanese',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '728',
    symbol: 'SS£',
    symbolNative: 'SS£',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SSP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SSP;
